module.exports = __webpack_public_path__ + "static/media/contactBanner-mcf.05b580fa.jpg";